import { apiSlice } from '../apiSlice'

export const accountApi = apiSlice.injectEndpoints({
	endpoints: (build) => ({
		getAccount: build.query({
			query: () => '/users/me/'
		})
	})
})

export const {
	useGetAccountQuery
} = accountApi